import React, { useEffect, useState } from "react";
import Image from "~/components/elements/Image";
import {CalendlyModal} from "~/components/elements/CalendlyModal";



export const VisitUs = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { title, content, addressTitle, address, image, links, iconBoxes } = props;
    
  // console.log('Links : ', links);
  
  return (
    <section className="bg-[#f6f9ff]  text-center font-sans">
      <div className="main-content-section max-w-3xl mx-auto">
        <h2 className="text-[40px] font-bold text-[rgb(11, 63, 111)] mb-4">{title}</h2>
        <div className="text-[19px] text-[rgb(82, 82, 91)] font-normal mb-12 pt-visit-us-below" dangerouslySetInnerHTML={{ __html: content }} />
        {image && (
            <div className="mb-8">
              <Image
                image={image}
                className="w-full max-w-xl mx-auto max-h-[424px]"
                alt="Visit location"
                loading="lazy"
              />
            </div>

        )}
        {addressTitle && (
          <h3 className="text-[31px] font-medium text-[rgb(11, 63, 111)] mb-4">
            {addressTitle}
          </h3>
        )}
        {address && (
          <div

            className="text-[23px] text-[#3D4F68] font-normal mb-6 pt-text leading-[35px] pt-mytext"

            dangerouslySetInnerHTML={{ __html: address }}
          />
        )}
        {links?.length > 0 && (
          <div className="flex flex-col sm:flex-row gap-9 justify-center items-center mt-6">
            {links.map((item, idx) => {
              const type = item.type;
              const link = item.link;
              const isPrimary = idx === 0;
              const buttonUrl = link?.url;
              const isCalendly = type === "calendly";
              const [modalOpen, setModalOpen] = useState(false);
              const buttonClass = `rounded-full px-6 py-3 font-semibold text-[16px] shadow-md transition-all duration-300 ${
                isPrimary
                  ? "bg-gradient-to-r bg-gradient-custom text-white hover:opacity-90 pt-book-appointment-button"
                  : "bg-white text-[#2664EB] border border-gray-300 hover:bg-gray-50 pt-contact-button"
              }`;

              return (
                <div key={idx} className="mt-4 pt-appointment-button">
                  {isCalendly ? (
                    <>
                    <CalendlyModal isOpen={modalOpen} onClose={() => setModalOpen(false)} calendlyUrl={buttonUrl} />
                    <button key={idx} onClick={() => setModalOpen(true)} className={buttonClass}>
                      {link?.title}
                    </button> 
                    </>
                  ) : (
                    <a key={idx} href={buttonUrl} className={buttonClass}>
                      {link?.title}
                    </a>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="bg-[#F7F9FD] pt-[140px] pb-[160px] pt-visitus-premium">
        <div className="max-w-7xl mx-auto  grid grid-cols-1 md:grid-cols-3 main-content-section">
          {iconBoxes.map((iconBoxData, index) => (
            <div key={index} className="flex items-center gap-4 bg-white shadow-sm rounded-[24px] p-6 w-[400px] h-[150px] pt-visit-premium-container">
              <div className="text-blue-500">
                <img
                  src={iconBoxData.iconBox.localFile.publicURL}
                  alt={iconBoxData.title}
                  className="w-[77px] h-[57px] text-blue-700 visitUsIconBoxImage"
                />
              </div>
              <p className="text-[#373D47] text-[23px]  text-left font-medium leading-snug pt-visit-us-icon-box-content">
                {iconBoxData.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
